import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {CaptchaService} from './captcha.service';
import { CaptchaComponent } from './captcha.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [CaptchaComponent],
  exports:[CaptchaComponent],
})
export class CaptchaModule {
  static forRoot() {
    return {
      ngModule: CaptchaModule,
      providers: [ CaptchaService ]
    };
  }
}
